import React from "react";
import { Colors } from "helpers/colors";

interface MessageIconProps {
  readonly isActive: boolean;
}

export const MessageIcon: React.FC<MessageIconProps> = ({ isActive }) => {
  return (
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <defs>
        <filter
          x="-28.4%"
          y="-28.4%"
          width="156.8%"
          height="156.8%"
          filterUnits="objectBoundingBox"
          id="filter-1"
        >
          <feMorphology
            radius="0.5"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="2"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="2"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="2"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0"
            type="matrix"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      <g
        id="Asset-Artboard-Page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="message-icon-button">
          <g id="Rectangle_203-6" filter="url(#filter-1)">
            <rect
              id="Rectangle"
              stroke={isActive ? Colors.DodgerBlue : "#B5D264"}
              fill={isActive ? Colors.AliceBlue : "#EFF4DF"}
              x="0.5"
              y="0.5"
              width="43"
              height="43"
              rx="9.5"
            ></rect>
            <path
              d="M18.4648438,20.1132812 C18.6731781,20.3216156 18.7773438,20.5755193 18.7773438,20.875 C18.7773438,21.1744807 18.6731781,21.4283844 18.4648438,21.6367188 C18.2565094,21.8450531 18.0026057,21.9492188 17.703125,21.9492188 C17.4036443,21.9492188 17.1497406,21.8450531 16.9414062,21.6367188 C16.7330719,21.4283844 16.6289062,21.1744807 16.6289062,20.875 C16.6289062,20.5755193 16.7330719,20.3216156 16.9414062,20.1132812 C17.1497406,19.9049469 17.4036443,19.8007812 17.703125,19.8007812 C18.0026057,19.8007812 18.2565094,19.9049469 18.4648438,20.1132812 Z M27.0585938,20.1132812 C27.2669281,20.3216156 27.3710938,20.5755193 27.3710938,20.875 C27.3710938,21.1744807 27.2669281,21.4283844 27.0585938,21.6367188 C26.8502594,21.8450531 26.5963557,21.9492188 26.296875,21.9492188 C25.9973943,21.9492188 25.7434906,21.8450531 25.5351562,21.6367188 C25.3268219,21.4283844 25.2226562,21.1744807 25.2226562,20.875 C25.2226562,20.5755193 25.3268219,20.3216156 25.5351562,20.1132812 C25.7434906,19.9049469 25.9973943,19.8007812 26.296875,19.8007812 C26.5963557,19.8007812 26.8502594,19.9049469 27.0585938,20.1132812 Z M22.7617188,20.1132812 C22.9700531,20.3216156 23.0742188,20.5755193 23.0742188,20.875 C23.0742188,21.1744807 22.9700531,21.4283844 22.7617188,21.6367188 C22.5533844,21.8450531 22.2994807,21.9492188 22,21.9492188 C21.7005193,21.9492188 21.4466156,21.8450531 21.2382812,21.6367188 C21.0299469,21.4283844 20.9257812,21.1744807 20.9257812,20.875 C20.9257812,20.5755193 21.0299469,20.3216156 21.2382812,20.1132812 C21.4466156,19.9049469 21.7005193,19.8007812 22,19.8007812 C22.2994807,19.8007812 22.5533844,19.9049469 22.7617188,20.1132812 Z M31.1992188,17.203125 C31.7330756,18.3750059 32,19.5924416 32,20.8554688 C32,22.1445377 31.7330756,23.3684838 31.1992188,24.5273438 C30.6914037,25.647141 29.975265,26.6367145 29.0507812,27.4960938 C28.1262975,28.355473 27.0651102,29.0260393 25.8671875,29.5078125 C24.6302021,29.9895857 23.3411525,30.2304688 22,30.2304688 C20.9322863,30.2304688 19.8906301,30.0742203 18.875,29.7617188 L15.984375,31.4023438 C15.8671869,31.4674482 15.7500006,31.5 15.6328125,31.5 C15.5156244,31.5 15.4114588,31.4739586 15.3203125,31.421875 C15.0989572,31.3046869 14.9687502,31.1223971 14.9296875,30.875 L14.4804688,27.046875 C13.6861939,26.1874957 13.0742209,25.2272188 12.6445312,24.1660156 C12.2148416,23.1048124 12,22.0013078 12,20.8554688 C12,19.5924416 12.2669244,18.3750059 12.8007812,17.203125 C13.3085963,16.0833277 14.024735,15.0872439 14.9492188,14.2148438 C15.8737025,13.3554645 16.9348898,12.6914086 18.1328125,12.2226562 C19.356777,11.740883 20.6458266,11.5 22,11.5 C23.3541734,11.5 24.643223,11.740883 25.8671875,12.2226562 C27.0651102,12.6914086 28.1262975,13.3554645 29.0507812,14.2148438 C29.975265,15.0872439 30.6914037,16.0833277 31.1992188,17.203125 Z M29.9296875,23.9414062 C30.372398,22.9648389 30.59375,21.9394585 30.59375,20.8652344 C30.59375,19.7910103 30.372398,18.7656299 29.9296875,17.7890625 C29.4999979,16.8385369 28.8880248,15.9954464 28.09375,15.2597656 C27.2994752,14.5240849 26.388026,13.9479187 25.359375,13.53125 C24.2916613,13.1145813 23.1718809,12.90625 22,12.90625 C20.8281191,12.90625 19.7083387,13.1145813 18.640625,13.53125 C17.611974,13.9348979 16.7005248,14.5078088 15.90625,15.25 C15.1119752,15.9921912 14.5000021,16.8385369 14.0703125,17.7890625 C13.627602,18.7656299 13.40625,19.7877551 13.40625,20.8554688 C13.40625,21.8580779 13.5983054,22.82161 13.9824219,23.7460938 C14.3665384,24.6705775 14.9231734,25.4973922 15.6523438,26.2265625 C15.7695318,26.3437506 15.8346354,26.480468 15.8476562,26.6367188 L16.1992188,29.6640625 L18.4453125,28.3945312 C18.6276051,28.2903641 18.8229156,28.270833 19.03125,28.3359375 C19.9817756,28.66146 20.971349,28.8242188 22,28.8242188 C23.1718809,28.8242188 24.2916613,28.6093771 25.359375,28.1796875 C26.388026,27.7760396 27.2994752,27.2096391 28.09375,26.4804688 C28.8880248,25.7382775 29.4999979,24.8919318 29.9296875,23.9414062 Z"
              id="message---anticon"
              stroke="#212B40"
              strokeWidth="0.6"
              fill="#212B40"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
